module.exports = __webpack_public_path__ + "static/media/29COICT1.d88945b6.jpg";